import { Link } from "react-router-dom";
import { Facebook, ExternalLink } from "lucide-react";
import { COMPANY, PRODUCTS } from "./data";

const ABOUT_LINKS = [
  { label: "Who We Are", to: "/about" },
  { label: "Our Vision", to: "/vision" },
  { label: "Our Team", to: "/team" },
  { label: "Our Foot Map", to: "/foot-map" },
];

export default function Footer({ onAdmin }) {
  return (
    <footer data-testid="corporate-footer" className="bg-slate-900 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/logo.jpg" alt="Laneeka International logo" className="h-10 w-10 object-contain rounded bg-white" />
            <span className="leading-none">
              <span className="block font-bold tracking-tight text-white">Laneeka</span>
              <span className="block text-[10px] uppercase tracking-widest text-slate-500">International</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed">
            {COMPANY.name} — a concern of {COMPANY.group} ({COMPANY.reference}). Exclusive Bangladesh
            agent of {COMPANY.agency}.
          </p>
          <div className="mt-4 flex items-center gap-4">
            <a data-testid="footer-laneeka-link" href={`https://${COMPANY.reference}`} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-400 hover:text-blue-300 transition-colors">
              {COMPANY.reference} <ExternalLink className="w-3.5 h-3.5" />
            </a>
            <a data-testid="footer-facebook-link" href={COMPANY.facebook} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-400 hover:text-white transition-colors">
              <Facebook className="w-4 h-4" /> Facebook
            </a>
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">About</p>
          <ul className="space-y-2 text-sm">
            {ABOUT_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-white transition-colors" data-testid={`footer-about-${l.to.slice(1)}`}>
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/products" className="hover:text-white transition-colors" data-testid="footer-products-link">
                Products &amp; Services
              </Link>
            </li>
            <li>
              <Link to="/news" className="hover:text-white transition-colors" data-testid="footer-news-link">
                News
              </Link>
            </li>
            <li>
              <Link to="/career" className="hover:text-white transition-colors" data-testid="footer-career-link">
                Career
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">Contact</p>
          <ul className="space-y-2 text-sm">
            <li><a data-testid="footer-phone" href={`tel:${COMPANY.phoneRaw}`} className="hover:text-white transition-colors">{COMPANY.phone}</a></li>
            <li><a data-testid="footer-email" href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors">{COMPANY.email}</a></li>
            <li data-testid="footer-address" className="leading-relaxed">{COMPANY.address}</li>
            <li data-testid="footer-hours">{COMPANY.hours}</li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">Find us</p>
          <div className="rounded-lg overflow-hidden border border-slate-700" data-testid="footer-map">
            <iframe
              title="Laneeka International location — Nikunja-2, Khilkhet, Dhaka"
              src="https://maps.google.com/maps?q=Nikunja%202%2C%20Khilkhet%2C%20Dhaka%201229%2C%20Bangladesh&t=&z=14&ie=UTF8&iwloc=&output=embed"
              className="w-full h-40 grayscale"
              loading="lazy"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © {COMPANY.established} – {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <button data-testid="footer-admin-link" onClick={onAdmin}
            className="text-xs text-slate-600 hover:text-blue-400 transition-colors">
            Admin
          </button>
        </div>
      </div>
    </footer>
  );
}
